import { Grid, Card, TextField, InputAdornment, Button } from "@material-ui/core";
import moment from "moment";
import "moment/locale/es";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { generateExcelEquivalencias, getEquivalenciasNomencladores } from "../../../actions/contrataciones/contratacionesConvenios";
import { startAlerta } from "../../../actions/ui/alertas";
import { finishSpinner, startSpinner } from "../../../actions/ui/spinner";
import { handleErrorApi } from "../../../helpers/randoms";
import ContratacionesConveniosService from "../../../services/ContratacionesConveniosService";
import AddButtonAbm from "../../compartidos/abms/AddButtonAbm";
import DeleteButtonAbm from "../../compartidos/abms/DeleteButtonAbm";
import EditButtonAbm from "../../compartidos/abms/EditButtonAbm";
import TableGeneric from "../../compartidos/abms/TableGeneric";
import { EquivalenciasNomencladoresForm } from "./EquivalenciasNomencladoresForm";
import { SearchIcon } from "@material-ui/data-grid";
import { AlertFinalizadoStepper } from "../../stepper/AlertFinalizadoStepper";
import ToolbarXLSPDF from "../../compartidos/ToolbarXLSPDF";

export const EquivalenciasNomencladores = ({ fieldsDisabled }) => {
  moment.locale("es");
  const dispatch = useDispatch();

  const { equivalenciasNomencladores } = useSelector((state) => state.contratacionesConvenios);
  const { dataContrato } = useSelector((state) => state.contrataciones);
  const [buscadorEquivalencia, setBuscadorEquivalencia] = useState("")
  const [openAlert, setOpenAlert] = useState(false);

  const handleSave = async (data, handleClose) => {
    try {
      dispatch(startSpinner())

      let result;
      if (data.idEquivalenciaNomencladores) {
        result = await ContratacionesConveniosService.editarEquivalencia(data.idEquivalenciaNomencladores, { ...data, idEfectorFacturacion: dataContrato.idEfectorFacturacion })
      } else {
        result = await ContratacionesConveniosService.crearEquivalencia({ ...data, idEfectorFacturacion: dataContrato.idEfectorFacturacion })
      }
      const body = await result.json()
      if (result.ok) {
        dispatch(finishSpinner())
        handleClose()
        dispatch(startAlerta("Equivalencia guardada correctamente", "success"))
        dispatch(getEquivalenciasNomencladores())
      } else {
        throw body
      }
    } catch (error) {
      dispatch(finishSpinner())
      handleErrorApi(dispatch, error, "Error al guardar la equivalencia", "Ha ocurrido un error. Intente nuevamente")
    }
  };

  const handleDelete = async (idEquivalenciaNomencladores, idEfectorFacturacion) => {
    try {
      dispatch(startSpinner())
      let result;
      if (idEfectorFacturacion) {
        result = await ContratacionesConveniosService.eliminarTodasEquivalencias(idEfectorFacturacion)
      } else {
        result = await ContratacionesConveniosService.eliminarEquivalencia(idEquivalenciaNomencladores)
      }
      const body = await result.json()
      if (result.ok) {
        dispatch(finishSpinner())
        dispatch(startAlerta("Equivalencia eliminada correctamente", "success"))
        dispatch(getEquivalenciasNomencladores())
        if (idEfectorFacturacion) {
          setOpenAlert(false);
        }
      } else {
        throw body
      }
    } catch (error) {
      dispatch(finishSpinner())
      handleErrorApi(dispatch, error, "Error al eliminar la equivalencia", "Ha ocurrido un error. Intente nuevamente")
    }
  };

  useEffect(() => {
    dispatch(getEquivalenciasNomencladores())
  }, [])
  console.log(dataContrato);
  return (
    <React.Fragment>
      <Grid container spacing={2}>
        <Grid item xs={12} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          <TextField
            placeholder="Buscar por Cód. Ospedyc o Cód. Prestador"
            onChange={(e) => setBuscadorEquivalencia(e.target.value)}
            value={buscadorEquivalencia}
            variant="outlined"
            InputProps={{
              endAdornment:
                <InputAdornment position="end">
                  <SearchIcon style={{ color: "#999" }} />
                </InputAdornment>
            }}
            autoComplete="off"
            style={{ width: '50%' }}
          />
        </Grid>
        <Grid item xs={12} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Grid item xs={6} style={{ paddingLeft: 0 }}>
            {
              !fieldsDisabled &&
              <AddButtonAbm
                title="+ Agregar equivalencia"
                handleSave={handleSave}
                permiso={null}
                form={EquivalenciasNomencladoresForm}
              />
            }
          </Grid>
          <Grid item xs={6} style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button variant='contained' color='primary' onClick={() => setOpenAlert(true)}>
              Eliminar Equivalencias
            </Button>
          </Grid>
          <Grid item xs={1} style={{ display: "flex", justifyContent: "flex-end" }}>
            <ToolbarXLSPDF
              handleExportExcel={() => dispatch(generateExcelEquivalencias(dataContrato.idEfectorFacturacion))}
            />
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Card>
            <TableGeneric
              data={buscadorEquivalencia === "" ? equivalenciasNomencladores :
                equivalenciasNomencladores.filter(item =>
                  item.codigoOspedyc.includes(buscadorEquivalencia) ||
                  item.descripcion.toLowerCase().includes(buscadorEquivalencia.toLowerCase())
                )}
              columns={[
                {
                  label: "",
                  customBody: (item) =>
                    !fieldsDisabled && (
                      <>

                        <EditButtonAbm
                          handleSave={handleSave}
                          permiso={null}
                          item={item}
                          form={EquivalenciasNomencladoresForm}
                        />

                        <DeleteButtonAbm
                          handleDelete={() => handleDelete(item.idEquivalenciaNomencladores, null)}
                          permiso={null}
                        />
                      </>
                    )
                },
                {
                  label: "Código Ospedyc",
                  id: "codigoOspedyc",
                  sort: true,
                },
                {
                  label: "Código Prestador",
                  id: "codigoPrestador",
                  sort: true,
                },
                {
                  label: "Descripcion",
                  id: "descripcion",
                  sort: true,
                },
              ]}
            />
          </Card>
        </Grid>
      </Grid>
      {openAlert && (
        <AlertFinalizadoStepper
          open={openAlert}
          pregunta={"¿Esta seguro que desea eliminar todas las equivalencias?"}
          dialogText={`Esto no puede revertirse.`}
          buttonCancel={"Cancelar"}
          buttonSubmit={"Aceptar"}
          handleClose={() => setOpenAlert(false)}
          handleSend={() => handleDelete(null, dataContrato.idEfectorFacturacion)}
        />
      )}
    </React.Fragment>
  );
};
